import { GET_COLLECTIONS } from '@/queries';

export default defineNuxtRouteMiddleware(() => {
  if (true) {
    const collectionStore = useCollectionSearchStore();
    const facilityCollections = useFacilityCollections();

    if (collectionStore.collections.length < 1) {
      const fetchCollections = async () => {
        const { data } = await useGraphQL(
          GET_COLLECTIONS,
          null
        );

        const collections = data?.value?.data.collections;
        collections && collectionStore.setCollections(collections.items);
        // THIS IS TEMPORARY
        facilityCollections.setCollections(collections.items);
      }
      fetchCollections();
    } else {
      facilityCollections.setCollections(collectionStore.collections);
    }
  }
});
